import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';

// project-imports
import SectionTitle from '../sectionTitle/SectionTitle';
import { GoogleAnalyticsEnum, triggerFunction } from '../../utils/google-analytics';

// Reading ENV variables
const NUMBER_OF_COURSES = process.env.REACT_APP_ABOUT_US_NUMBER_OF_COURSES;
const NUMBER_OF_VIDEOS = process.env.REACT_APP_ABOUT_US_NUMBER_OF_YOU_TUBE_VIDEOS;
const ABOUT_US_MAIN_DESCRIPTION = process.env.REACT_APP_ABOUT_US_MAIN_DESCRIPTION;
const ABOUT_US_MAIN_LINK = process.env.REACT_APP_ABOUT_US_MAIN_LINK_PIECE;
const ABOUT_US_MAIN_LINK_TEXT = process.env.REACT_APP_ABOUT_US_MAIN_LINK_TEXT;
// Constant features 
const features = [
    {
        icon: 'icon-award-fill',
        title: `${NUMBER_OF_COURSES}+ Verified Courses`
    },
    {
        icon: 'icon-video-fill',
        title: `${NUMBER_OF_VIDEOS}+ Free Videos`
    },
    {
        icon: 'icon-user-fill',
        title: 'Expert Instructors'
    },
    {
        icon: 'icon-flag-fill',
        title: 'Big Student Community'
    }
];

const AboutUsPageSection = () => {

    // Reading environment variable start
    const YOUTUBE_CHANNEL_URL = process.env.REACT_APP_YOUTUBE_CHANNEL_URL;
    // Reading environment variable end

    return (
        <div className="edu-about-area about-style-3 edu-section-gap bg-image">
            <div className="container eduvibe-animated-shape">
                <div className="row g-5 align-items-center">
                    <div className="col-xl-6 col-lg-6 pr--80">
                        <ScrollAnimation
                            animateIn="fadeIn"
                            animateOut="fadeInOut"
                            className="gappery-wrapper"
                            delay={150}
                            animateOnce={true}
                        >
                            <div className="row g-5 align-items-end">
                                <div className="col-lg-5 col-md-6">
                                    <div className="gallery-image mt--85">
                                        <img className="w-100" src="/images/about/about-04/gallery-1.jpg" alt="Gallery Images" loading='lazy' />
                                        <div className="icon-badge">
                                            <i className="icon-ribbon"></i>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-7 col-md-6">
                                    <div className="gallery-image">
                                        <img className="w-100" src="/images/about/about-04/gallery-4.jpg" alt="Gallery Images" />
                                    </div>
                                </div>

                                <div className="col-lg-12">
                                    <div className="gallery-image gallery-image-3 text-center">
                                        <img src="/images/about/about-04/gallery-3.jpg" alt="Gallery Images" />

                                        <div className="student-like-status bounce-slide">
                                            <div className="inner">
                                                <div className="icon">
                                                    <i className="icon-Smile"></i>
                                                </div>
                                                <div className="content">
                                                    <h6 className="title">{process.env.REACT_APP_LONGSWITCH_ACADEMY_SUBSCRIBERS}</h6>
                                                    <span className="subtitle">Total Subscribers</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ScrollAnimation>
                    </div>
                    <div className="col-lg-6">
                        <div className="inner  mt_md--40 mt_sm--40">
                            <SectionTitle
                                classes="text-start"
                                slogan="Why You Will Choose Guidence"
                                title="Creating A Community Of Life Long Learners"
                            />

                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}
                            >
                                <p className="line-before mt--5 mb--5 fs-15">
                                    {ABOUT_US_MAIN_DESCRIPTION}
                                </p>
                            </ScrollAnimation>
                            <div className="feature-style-2">
                                {(features || []).map((item, i) => (
                                    <ScrollAnimation
                                        animateIn="fadeInUp"
                                        animateOut="fadeInOut"
                                        animateOnce={true}
                                        className="single-feature"
                                        key={i}
                                    >
                                        <div className="icon">
                                            <i className={item?.icon}></i>
                                        </div>
                                        <div className="content">
                                            <h6 className="feature-title">{item?.title}</h6>
                                        </div>
                                    </ScrollAnimation>
                                ))}
                            </div>
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                className="read-more-btn mt--60"
                                animateOnce={true}
                            >
                                <a href={process.env.PUBLIC_URL + ABOUT_US_MAIN_LINK}
                                    target="_self"
                                    onClick={() =>
                                        triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.ABOUT_US_PAGE_CHOOSE_GUIDENCE_EXPLORE_COURSES)}
                                    className="edu-btn" rel="noreferrer">
                                    {ABOUT_US_MAIN_LINK_TEXT}<i className="icon-arrow-right-line-right"></i>
                                </a>
                            </ScrollAnimation>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutUsPageSection;